module.exports = __webpack_public_path__ + "img/Frame 1059five.ba556e53.png";